import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { IActionButtonProps } from '@/@types/photostudio';

export function ActionButton({
  variant,
  icon: Icon,
  children,
  onClick,
  disabled = false,
  loading = false,
  title,
}: IActionButtonProps) {
  const isDisabled = disabled || loading;

  const variantStyles = {
    primary: cn('bg-primary border-primary text-primary-foreground', 'hover:bg-primary/90'),
    secondary: cn(
      'bg-secondary border-secondary text-secondary-foreground',
      'hover:bg-secondary/80'
    ),
  };

  return (
    <button
      type="button"
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
      title={title}
      className={cn(
        'flex h-12 w-full items-center justify-center gap-2.5 rounded-lg border font-semibold text-[13px] uppercase tracking-wider',
        'transition-colors',
        variantStyles[variant],
        isDisabled && 'cursor-not-allowed opacity-50'
      )}
    >
      {loading ? (
        <Loader2 className="h-5 w-5 animate-spin" />
      ) : Icon ? (
        <Icon className="h-5 w-5" />
      ) : null}
      {children}
    </button>
  );
}
